export default "__VITE_ASSET__djZxVyEw__"